import { stringValidator } from '#validation/common/validators';
export const storageProviderIdValidator = stringValidator({
    requiredError: 'filespace.storageProviderId.required',
});
